export const LOGIN_REG_TEAM = 'LOGIN_REG_TEAM'
// export const LOGIN_CONFIRM_RESET_PASSWORD = 'LOGIN_CONFIRM_RESET_PASSWORD'
// export const LOGIN_SUBMIT_NEW_PASSWORD = 'LOGIN_SUBMIT_NEW_PASSWORD'
export const LOGIN_WITH_PHONE = 'LOGIN_WITH_PHONE'
export const LOGIN_WITH_EMAIL = 'LOGIN_WITH_EMAIL'
export const LOGIN_RQST_SMS_VALIDATION = 'LOGIN_RQST_SMS_VALIDATION'
export const LOGIN_SUBMIT_ROBOT_VERIF_CODE = 'LOGIN_SUBMIT_ROBOT_VERIF_CODE'
export const LOGIN_SMS_VALIDATE = 'LOGIN_SMS_VALIDATE'
export const LOGIN_GET_SMS_LEFT_TIME = 'LOGIN_GET_SMS_LEFT_TIME'

export const INIT_WECHAT_JS_CONFIG = 'INIT_WECHAT_JS_CONFIG'

export const LOGOUT = 'LOGOUT'
export const GET_TEAM_INFO = 'GET_TEAM_INFO'
export const GET_USER = 'GET_USER'
export const GET_NOTIFICATION_STATUS = 'GET_NOTIFICATION_STATUS'
export const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION'

export const DASHBOARD_GET_STAT = 'DASHBOARD_GET_STAT'
export const DASHBOARD_GET_NEWS = 'DASHBOARD_GET_NEWS'
export const DASHBOARD_GET_DIALOG = 'DASHBOARD_GET_DIALOG'

export const CONTACT_GET_LIST = 'CONTACT_GET_LIST'
export const CONTACT_GET_CONTACT = 'CONTACT_GET_CONTACT'
export const CONTACT_GET_ORG = 'CONTACT_GET_ORG'
export const CONTACT_GET_TAGGED_LIST = 'CONTACT_GET_TAGGED_LIST'
export const CONTACT_GET_CONTACT_FORMFILLS = 'CONTACT_GET_CONTACT_FORMFILLS'
export const CONTACT_GET_CONTACT_SIGNUPS = 'CONTACT_GET_CONTACT_SIGNUPS'
export const CONTACT_GET_CONTACT_DONATES = 'CONTACT_GET_CONTACT_DONATES'
export const CONTACT_GET_CONTACT_DONATE_STAT = 'CONTACT_GET_CONTACT_DONATE_STAT'
export const CONTACT_GET_CONTACT_REMARKS = 'CONTACT_GET_CONTACT_REMARKS'
export const CONTACT_GET_CONTACT_ATTACHMENTS = 'CONTACT_GET_CONTACT_ATTACHMENTS'

export const FORM_GET_LIST = 'FORM_GET_LIST'
export const FORM_GET = 'FORM_GET'
export const FORM_GET_FEEDBACK_LIST = 'FORM_GET_FEEDBACK_LIST'
export const FORM_SEARCH_FEEDBACK = 'FORM_SEARCH_FEEDBACK'
export const FORM_GET_FEEDBACK_DETAIL = 'FORM_GET_FEEDBACK_DETAIL'
export const FORM_GET_RECORD_NOTES = 'FORM_GET_RECORD_NOTES'

export const CF_GET_LIST = 'CF_GET_LIST'
export const CF_GET = 'CF_GET'
export const CF_GET_FEEDBACK_LIST = 'CF_GET_FEEDBACK_LIST'
export const CF_SEARCH_FEEDBACK = 'CF_SEARCH_FEEDBACK'
export const CF_GET_FEEDBACK_DETAIL = 'CF_GET_FEEDBACK_DETAIL'

export const SEARCH = 'SEARCH'
export const GET_SHARE = 'GET_SHARE'

export const ZHUGE_IDENTIFY = 'ZHUGE_IDENTIFY'
export const ZHUGE_TRACK = 'ZHUGE_TRACK'

export const GEETEST_INIT = 'GEETEST_INIT'
export const GEETEST_DESTORY = 'GEETEST_DESTORY'

export const ACTIVITY_GET_LIST = 'ACTIVITY_GET_LIST'
export const ACTIVITY_GET_DETAIL = 'ACTIVITY_GET_DETAIL'
export const ACTIVITY_GET_COUNT = 'ACTIVITY_GET_COUNT'
export const ACTIVITY_GET_FEEDBACK = 'ACTIVITY_GET_FEEDBACK'
export const ACTIVITY_GET_SIGN_UP = 'ACTIVITY_GET_SIGN_UP'
export const ACTIVITY_GET_FEEDBACK_DETAIL = 'ACTIVITY_GET_FEEDBACK_DETAIL'
export const ACTIVITY_GET_FEEDBACK_LIST = 'ACTIVITY_GET_FEEDBACK_LIST'
export const ACTIVITY_SET_FEEDBACK_SIGNUPLIST = 'ACTIVITY_SET_FEEDBACK_SIGNUPLIST'
export const ACTIVITY_POST_SIGNIN = 'ACTIVITY_POST_SIGNIN'
export const ACTIVITY_POST_SIGNOUT = 'ACTIVITY_POST_SIGNOUT'
export const ACTIVITY_POST_CANCEL_SIGNIN = 'ACTIVITY_POST_CANCEL_SIGNIN'
export const ACTIVITY_GET_SIGNIN_STATISTICS = 'ACTIVITY_GET_SIGNIN_STATISTICS'

export const SAVE_LX_PASSWORD = 'SAVE_LX_PASSWORD'

export const DASHBOARD_GET_TEAM_INFO = 'DASHBOARD_GET_TEAM_INFO'
export const FETCH_WECHAT_JS_CONFIG = 'FETCH_WECHAT_JS_CONFIG'

export const REGISTER_TEAM_COUNT = 'REGISTER_TEAM_COUNT'



// WEBPACK FOOTER //
// ./src/store/action-types.js